import moment from "moment";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";

import styles from "./IncreasedOrDecreasedMedicationText.module.scss";

interface IIncreasedOrDecreasedMedicationTextProps {
    medicationModel: MedicationModel;
    isDosageStringVisible?: boolean;
}

export function IncreasedOrDecreasedMedicationText(props: IIncreasedOrDecreasedMedicationTextProps): JSX.Element {
    const { getText } = useTranslation();

    let iconCssName = "";

    if (props.medicationModel.PrescriptionTab_OriginalMedication.Model.PrescriptionTab_PendingStatus == "2") {
        iconCssName = "glyphicon-triangle-top";
    }
    else if (props.medicationModel.PrescriptionTab_OriginalMedication.Model.PrescriptionTab_PendingStatus == "3") {
        iconCssName = "glyphicon-triangle-bottom";
    }

    return (
        <>
            <div>
                <span
                    className={`glyphicon ${iconCssName} ${styles.medicationName} ${styles.mr5}`}
                />
            </div>
            <div>
                <span className={styles.medicationName}>{props.medicationModel.GetNameForChildMedication(false)}</span>
            </div>
            {props.isDosageStringVisible && (
                <div>
                    <span className={`${styles.ml6}`}>{props.medicationModel.PrescriptionTab_OriginalMedication.GetDosageString({ includeDaysOrQty: false })}</span>
                </div>
            )}
            <div>
                <span className={`${styles.ml6} ${styles.italic}`}>{getText("DateOf")}</span>
            </div>
            <div>
                <span className={`${styles.ml6} ${styles.italic}`}>
                    {moment(props.medicationModel.PrescriptionTab_OriginalMedication.Model.CeaseDate).format("YYYY-MM-DD") + ","}
                </span>
            </div>
        </>
    );
}
